import * as React from 'react'
import { useTheme } from 'next-themes'
import { Button } from '~/sotano-kit/primitives/button'
import { fragmentOn } from 'basehub'
import { SunIcon } from '@radix-ui/react-icons'
import { useFloatingBanner } from '../context'

export const TryLightModeFragment = fragmentOn('TryLightModeComponent', {
  __typename: true,
  _id: true,
})

export type TryLightModeFragment = fragmentOn.infer<typeof TryLightModeFragment>

export const TryLightModeComponent = (_: TryLightModeFragment) => {
  const { setTheme, resolvedTheme } = useTheme()
  const { onClose } = useFloatingBanner()

  return (
    <Button
      className="my-3 group-last:mb-0 cursor-default flex gap-1 items-center hover:text-dark-dim text-dark-muted"
      unstyled
      onClick={() => {
        if (resolvedTheme === 'light') {
          onClose()
        } else {
          setTheme('light')
        }
      }}
    >
      <SunIcon />
      {resolvedTheme === 'light' ? (
        <>Doesn't it look great? Click to close.</>
      ) : (
        <>Try now</>
      )}
    </Button>
  )
}
